import React, { useEffect, useState } from 'react';
import Spinner from 'sushiweb/Spinner/Spinner';
import { userModel } from '../../../api';
import { InvalidSearchImg } from '../../../images/images';
import { Button, Loader } from '../../../UiKit';
import { EmptyState } from '../../commons';
import CartDetailsCard from './CartDetailsCard';

function UserCarts({ userId }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showRefunds, setShowRefunds] = useState({});
  const [cartPayload, setCartPayload] = useState({});
  const [noMoreCarts, setNoMoreCarts] = useState(false);

  useEffect(() => {
    loadCarts();
  }, [userId]);

  const loadCarts = () => {
    const fetchData = async () => {
      let payload = {
        ...cartPayload,
        customer_id: userId,
      };
      const res = await userModel.getCarts(payload);

      if (res.isError) {
        setError(res);
      }

      if (res?.cart_list?.length === 0) {
        setNoMoreCarts(true);
      }
      if (res?.cart_list?.length) {
        if (data.length > 0)
          setData((prevData) => {
            return [...prevData, ...res?.cart_list];
          });
        else setData(res.cart_list);
        const lastIndex = res.cart_list.length - 1;
        setCartPayload({
          lst_cart_id: res.cart_list[lastIndex]?.cart_id,
          lst_install_ts: res.cart_list[lastIndex]?.install_ts,
        });
        handleRedundVisibilty();
      }
    };
    setIsLoading(true);
    fetchData()
      .then(() => setIsLoading(false))
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  };

  const handleRedundVisibilty = (cartId) => {
    let showRefundObj = {};
    for (let i = 0; i < data.length; i++) {
      if (data[i].cart_id === cartId)
        showRefundObj = {
          ...showRefunds,
          [cartId]: showRefunds[`${cartId}`] ? false : true,
        };
    }
    setShowRefunds(showRefundObj);
  };

  if (isLoading && data.length === 0)
    return (
      <div className='tw-w-full tw-min-h-[70vh] tw-flex tw-items-center tw-justify-center'>
        <Loader />
      </div>
    );
  if (error || (!isLoading && data?.length === 0)) {
    return (
      <div className='tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center'>
        <EmptyState
          img={InvalidSearchImg}
          heading={error?.message || 'No cart available!'}
          isPop={true}
        />
      </div>
    );
  }
  if (data.length === 0) return null;
  return (
    <div className='tw-flex tw-flex-col tw-pt-4 tw-pb-4'>
      {data.map((cardDetails) => {
        return (
          <CartDetailsCard
            customerId={userId}
            cardDetails={cardDetails}
            showRefunds={
              cardDetails?.cart_id && showRefunds[cardDetails.cart_id]
            }
            setShowRefund={handleRedundVisibilty}
          />
        );
      })}
      <div className='tw-flex tw-items-center tw-justify-center'>
        <div className='tw-w-full tw-flex tw-justify-center tw-items-center'>
          {isLoading ? (
            <Spinner color='#318616' size='small' />
          ) : (
            data?.length >= 5 &&
            (!noMoreCarts ? (
              <Button
                title='Load more carts'
                size='compressed'
                outline={true}
                onClick={loadCarts}
              />
            ) : (
              <div className='tw-w-full tw-bg-grey-100 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded-lg'>
                <div className='tw-text-grey-600 tw-w-full tw-flex tw-justify-center tw-items-center'>
                  There are no more carts available for this customer.
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export { UserCarts };
